export const FIELD_ERROR_SCROLL_SELECTOR = '[data-ob-scroll-error="true"]';

export const FIELD_SCROLL_MARGIN_TOP = 160;

export const MOBILE_FIELD_SCROLL_MARGIN_TOP = 200;
